/**
 * Fix an element based on scroll position
 * @module fixedScroll
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'fixedScroll';
export const DEFAULTS = {
  offClass: '',
  parentElement: $(window),
  scrollOffPosition: '.site-footer__container'
};
/**
 * Applies any sort of event handlers for the fixedScroll.
 * @param  {jQuery} $el - element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options = {}) => {
  $(window).on("scroll resize", function(){
    const $window = $(this);
    const docHeight = $(document).height();
    const windowHeight = $window.height();
    let currentScrollPosY = options.parentElement.scrollTop();
    const scrollOffPosition = $(options.scrollOffPosition).outerHeight(true);
    const offScrollPosY =  docHeight - scrollOffPosition - windowHeight;

    if (currentScrollPosY >=  offScrollPosY) {
      $el.addClass(options.offClass);
    } else {
      $el.removeClass(options.offClass);
    }
  });
}
/**
 * Initializes fixedScroll
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function fixedScroll(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, fixedScroll);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-scroll.js